import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import { format, startOfDay, endOfDay } from "date-fns";
import "../../../assets/css/scheduledBookingType.css";
import { UserContext } from "../../auth/auth-context";
import BookingRecord from "./bookingRecord";
import { GET_BOOKING_ANSWERS } from "../../../graphql/queries";
import Error from "../../common/error";
import { useCalendar } from "../calendar/calendarContext";
import { BookingTypeStatus } from "../../../util/utils";
import { formatInTimeZone } from "date-fns-tz";
import { useLocation, useNavigate } from "react-router-dom";

export function ScheduledBookingType() {
  const { providerUser } = useContext(UserContext); 
  const { bookingDatas, myBookingTypes, currentMonth } = useCalendar(); 
  const navigate = useNavigate();
  const location = useLocation(); // current page info



  // Query booking answers for the current provider.
  const {
    loading: answersLoading,
    error: answersError,
    data: answersData,
  } = useQuery(GET_BOOKING_ANSWERS, {
    variables: { staffId: providerUser.staffId, email: providerUser.email },
    skip: (!providerUser.staffId && !providerUser.email),
  });

  if (!providerUser?.email) {
    navigate("/login", {
      state: { from: location.pathname },
       replace: true,
    });
    return null;
  }

  if (answersLoading) return "Loading...";
  if (answersError) {
    console.error(answersError);
    return <Error />;
  }

  // Helper to fetch booking type details.
  const getBookingDetail = (booking) => {
    return myBookingTypes?.find(
      (e) => Number(e.id) === Number(booking?.bookingTypeId)
    );
  };
 
  // Only filter out bookings that are marked as deleted.
  const sortedBookings = [...bookingDatas].sort(
    (a, b) => new Date(a.time) - new Date(b.time)
  ).filter((booking) => booking.status !== BookingTypeStatus.DELETED);

  const currentYear = currentMonth.getFullYear();
  const startOfYear = startOfDay(new Date(currentYear, 0, 1));
  const endOfYear = endOfDay(new Date(currentYear, 11, 31));
  const now = new Date();

  // Build upcoming bookings: filter by primary time being in the future (even if it's an exception, keep for recurring expansion).
  const upcomingBookings = sortedBookings.filter((booking) => {
    const bookingDate = new Date(booking.time);
    return (
      bookingDate >= now &&
      bookingDate >= startOfYear &&
      bookingDate <= endOfYear
    );
  });

  // Group upcoming bookings by formatted date.
  const upcomingBookingsMap = new Map();
  upcomingBookings.forEach((booking) => {
    const dateKey = formatInTimeZone(new Date(booking.time), providerUser.timeZone.timezone, "EEEE, MMMM d, yyyy");
    if (!upcomingBookingsMap.has(dateKey)) {
      upcomingBookingsMap.set(dateKey, []);
    }
    upcomingBookingsMap.get(dateKey).push(booking);
  });
  const upcomingBookingsArray = Array.from(upcomingBookingsMap, ([date, bookings]) => ({
    date,
    bookings,
  }));
 
  return (
    <Box>
      <BookingRecord
        currentYear={currentYear}
        bookingType="upcoming"
        bookingsArray={upcomingBookingsArray}
        getBookingDetail={getBookingDetail}
        answersData={answersData}
        timezone={providerUser?.timeZone?.timezone}
      />
    </Box>
  );
}

export default ScheduledBookingType;
